import styled from "styled-components";
import { motion } from "framer-motion";

export const MainSection = styled.section`
  .logo {
    width: 237px;
    height: 59px;
  }

  .navbar-toggler {
    background-color: #f2bd51 !important;
  }

  .navbar-nav {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }

  a {
    font-size: 20px;
    font-style: italic;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(255, 255, 255, 1);
    margin-right: 1.5rem;

    &.active {
      color: #f7c13a !important;
    }

    &.non-active {
      /* cursor: not-allowed !important; */
      /* opacity: 0.5; */
    }
  }

  .nav-link {
    color: #e4c42b;
    font-family: "Inter";
    font-size: 25.275px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: capitalize;

    /* &:not(:first-child) {
      margin-left: 1.2rem;

      @media (max-width: 990px) {
        margin-left: 0rem;
      }
    } */

    @media (max-width: 990px) {
      text-align: center;
    }
  }

  @media (max-width: 990px) {
    .logo {
      width: 13.42119rem;
      height: 3.35206rem;
    }
  }

  .toggle {
    @media (max-width: 990px) {
      display: none;
    }
  }

  .menu {
    @media (min-width: 990px) {
      display: none;
    }
  }

  .navbar-nav .nav-link.active,
  .navbar-nav .nav-link.show {
    color: #e4c42b !important;
  }

  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 215px;
    height: 46px;
    margin-left: 2rem;
    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: rgba(51, 29, 1, 1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .navbar {
    background: rgba(8, 6, 3, 0.3);
    backdrop-filter: blur(15.75px);
  }
`;

export const ConnectBtn = styled.button`
  color: #000;
  font-family: "Inter";
  font-size: 22.577px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-radius: 5.5px;
  background: var(--yellow, linear-gradient(180deg, #e0c528 0%, #f7c13a 100%));
  width: 241px;
  height: 54.218px;
  border: none;

  &:hover {
    border-radius: 0.34375rem;
    background: #9b8400;
    color: #fff;
  }

  @media (max-width: 990px) {
    margin-top: 1rem;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const DrawerDiv = styled(motion.div)`
  height: 100vh;
  display: flex;
  justify-content: flex-end;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999 !important;

  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 215px;
    height: 46px;
    margin-left: 0rem !important;
    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: rgba(51, 29, 1, 1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  /* .staking-text {
    opacity: 0.5;
  } */
`;

export const InnerDrawer = styled(motion.div)`
  width: 268px;
  border: 1px solid #000;
  background: #0f0b00;
  height: 100vh;
  border-left: 1px solid #e0c528;
  position: relative;
  padding: 0rem 1rem;

  .close {
    position: absolute;
    top: 1rem;
    left: 1rem;
  }

  .top-logo-div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e0c528;
    margin-top: 3rem;

    img {
      width: 200px;
    }
  }

  .bottom-div {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;

    h4 {
      color: #e4c42b;
      font-family: "Inter";
      font-size: 25.275px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: capitalize;
    }
  }
`;
